import React from 'react';

export default class DragButton extends React.Component {

    draggable(element, type) {
        const product = APP.findProductsByType(type)[0];
        APP.interactionHandler.draggable(element)
            .setDragObject3D((handle) => APP.model.createDragObject(product))
            .onTap((handle) => this.onClick());

    }

    onClick() {
        APP.uiHandler.dialog({
            title: I18N("Einfach ziehen!"),
            text: I18N("Ziehen Sie das Symbol einfach auf den Schrank, um das Element zu platzieren."),
            buttons: [
                {
                    style: 'primary',
                    label: I18N("In Ordnung!")
                }
            ]
        })
    }


    render() {
        //console.log("DRAGBUTTON RENDER");
        return (
            <div className="image-text stop-select"  ref={e => {this.draggable(e, this.props.type);}} onClick={this.onClick}>
                <div className="image no-pointer"><img className={(this.props.class ? this.props.class:"")} src={this.props.image}/></div>
                {this.props.label}
            </div>
        );
    }
}